import styled from 'styled-components';

const SmallChartsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 0 auto;
`;

export default SmallChartsContainer;
